import { AnalyticsPlugin } from './analytics-plugin.types';

import { getLogger } from '@/logger/logger';

const logger = getLogger(
  'LocalAnalytics',
);

export class LocalAnalytics implements AnalyticsPlugin {
  track(eventName: string) {
    logger.debug('Analytics event tracked', { analytics: { event: eventName } });
  }

  trackCharge(amount: number): void {
    logger.debug('Analytics charge tracked', { analytics: { event: 'charge', amount } });
  }

  async identify(userId: string): Promise<void> {
    logger.debug('Analytics identity set', { analytics: { event: 'identify' }, user: { id: userId } });
  }

  reset(): void {
    logger.debug('Analytics identity reset', { analytics: { event: 'reset' } });
  }

  async getCurrentSessionId(): Promise<string | undefined> {
    return undefined;
  }
}
